import { useDispatch, useSelector } from 'react-redux';
import ConsultedEntities from '../ConsultedEntities';
import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import ChatIcon from '@/public/images/dashboard/chat.svg';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import { getPerformancePropertyConsultationsCard } from '@/store/slices/components/dashboard/service';

function getMostCard(performanceTab) {
  const mostSectionId = 'SearchTrends';
  const mostCardId = 'MostInquiredProperties';

  const foundSection = performanceTab.sections.find(
    (section) => section.id === mostSectionId
  );
  const most = (foundSection?.cards || []).find(
    (card) => card.id === mostCardId
  );

  return most;
}

function LeastConsultedProperties() {
  // This component doesn't fetch the data
  // "MostConsultedProperties" retrieves the most and least consulted properties
  const dispatch = useDispatch();
  const track = useTrackPerformanceTabCard();
  const { tabs } = useSelector((state) => state.DashboardSlice.edition);

  const mostCard = getMostCard(tabs.performance);
  // fallback when most consulted properties is hidden
  const shouldFetch = !mostCard.visible;

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'propertyConsultations',
        subkey: 'sortBy',
        value: 'inquiry',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'propertyConsultations',
        subkey: 'sortDirection',
        value: 'asc',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'propertyConsultations',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <ConsultedEntities
      id="least-consulted-properties"
      title={Trans(translations, 'LeastInquiredProperties')}
      stateKey="propertyConsultations"
      stateSubkey="least_consulted"
      entityType="property"
      fetchCallback={(query) => {
        if (!shouldFetch) return;
        dispatch(getPerformancePropertyConsultationsCard({ query }));
      }}
      trackCallback={(element) => track.leastInquiriedProperties(element)}
      openTableCallback={handleOpenTable}
      emptyStateChildren={
        <DashboardEmptyStateCard
          icon={ChatIcon}
          title={Trans(
            translations,
            'HereYouWillSeeYourLeastInquiredProperties'
          )}
          description={Trans(
            translations,
            'PromotingYourPropertiesIsKeyToFindLeads'
          )}
        />
      }
    />
  );
}

export default LeastConsultedProperties;
